import type { Invoice } from '../../../types';

function timestampMillis(value: unknown): number | null {
  if (!value) return null;
  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : parsed;
  }
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'object') {
    const timestamp = value as {
      toMillis?: () => number;
      toDate?: () => Date;
      seconds?: number;
    };
    if (typeof timestamp.toMillis === 'function') return timestamp.toMillis();
    if (typeof timestamp.toDate === 'function') return timestamp.toDate().getTime();
    if (typeof timestamp.seconds === 'number') return timestamp.seconds * 1000;
  }
  return null;
}

function plannedSendMillis(invoice: Invoice): number | null {
  return timestampMillis(invoice.plannedSendDate || invoice.invoiceSendDate || invoice.invoiceDate);
}

function createdMillis(invoice: Invoice): number {
  return timestampMillis(invoice.createdAt) ?? 0;
}

export function comparePartnerInvoices(left: Invoice, right: Invoice): number {
  const leftSent = Boolean(left.sentAt);
  const rightSent = Boolean(right.sentAt);

  if (leftSent !== rightSent) return leftSent ? 1 : -1;

  const leftDate = leftSent ? timestampMillis(left.sentAt) : plannedSendMillis(left);
  const rightDate = rightSent ? timestampMillis(right.sentAt) : plannedSendMillis(right);

  if (leftDate !== null && rightDate !== null && leftDate !== rightDate) return leftDate - rightDate;
  if (leftDate === null && rightDate !== null) return 1;
  if (leftDate !== null && rightDate === null) return -1;

  return createdMillis(right) - createdMillis(left) || left.id.localeCompare(right.id);
}

